module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	")
    ;  var visible; 
    ; __append("\n\n	")
    ; 
	visible = false;
	if (widget.playingStatus == "play" || widget.playingStatus == "pause") {
		visible = true;
	}
	
    ; __append("\n	<button on-click=\"onRewindToStepClick\" data-direction=\"backward\" title=\"Перемотать назад\"\n		")
    ; __append(escapeFn( visible ? "" : "style='display: none'" ))
    ; __append(">Назад</button>\n\n	")
    ; 
	visible = false;
	if (widget.playingStatus == "stop") {
		visible = true;
	}
	
    ; __append("\n	<button on-click=\"onPlayClick\" title=\"Начать\"\n		")
    ; __append(escapeFn( visible ? "" : "style='display: none'" ))
    ; __append(">Начать</button>\n\n	")
    ; 
	visible = false;
	if (widget.playingStatus == "play") {
		visible = true;
	}
	
    ; __append("\n	<button on-click=\"onPauseClick\" title=\"Пауза\"\n		")
    ; __append(escapeFn( visible ? "" : "style='display: none'" ))
    ; __append(">Пауза</button>\n\n	")
    ; 
	visible = false;
	if (widget.playingStatus == "pause") {
		visible = true;
	}
	
    ; __append("\n	<button on-click=\"onContinueClick\" title=\"Продолжить\"\n		")
    ; __append(escapeFn( visible ? "" : "style='display: none'" ))
    ; __append(">Продолжить</button>\n\n	")
    ; 
	visible = false;
	if (widget.playingStatus == "play" || widget.playingStatus == "pause") {
		visible = true;
	}
	
    ; __append("\n	<button on-click=\"onResetClick\" title=\"Остановить и вернуться на начало\"\n		")
    ; __append(escapeFn( visible ? "" : "style='display: none'" ))
    ; __append(">Стоп</button>\n\n	")
    ; 
	visible = false;
	if (widget.playingStatus == "play" || widget.playingStatus == "pause") {
	visible = true;
	}
	
    ; __append("\n	<button on-click=\"onRewindToStepClick\" data-direction=\"forward\" title=\"Перемотать вперед\"\n		")
    ; __append(escapeFn( visible ? "" : "style='display: none'" ))
    ; __append(">Вперед</button>\n</div>\n")
  }
  return __output.join("");

}